module.exports = __webpack_public_path__ + "img/signal-catch.4d46fccc.svg";